// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../client/web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../client/web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChatInterface - Ethereal Tech Design
 *
 * Pure chat view: header, messages, input, bot drawer.
 * Positioned within the main panel of AppLayout.
 */

.chat-interface {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: transparent;
  color: var(--text-primary);
  z-index: 1;
}

/* ===== Header ===== */
.chat-header {
  position: relative;
  flex-shrink: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border-bottom: 1px solid var(--glass-border);
  z-index: var(--z-header);
}

.chat-header::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, transparent 100%);
  pointer-events: none;
}

.chat-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.chat-header-left {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.chat-back-button {
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  color: var(--text-tertiary);
  cursor: pointer;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.chat-back-button:hover {
  color: var(--text-primary);
  border-color: var(--color-primary);
  background: var(--glass-bg);
}

.chat-title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--letter-spacing-tight);
  background: linear-gradient(135deg, var(--text-primary) 0%, var(--color-accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  cursor: default;
}

.chat-title-input {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  padding: 2px 6px;
  font-family: inherit;
  -webkit-text-fill-color: var(--text-primary);
  background: var(--glass-bg);
  outline: none;
  width: 200px;
}

.chat-header-right {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

/* ===== Bots Button ===== */
.bots-button {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--glass-bg);
  backdrop-filter: blur(var(--blur-sm));
  -webkit-backdrop-filter: blur(var(--blur-sm));
  color: var(--text-secondary);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-base);
  white-space: nowrap;
}

.bots-button:hover {
  color: var(--text-primary);
  border-color: var(--color-primary);
  box-shadow: 0 0 20px var(--color-primary-glow);
}

.bots-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: var(--color-primary);
  color: white;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: var(--font-weight-semibold);
  line-height: 1;
}

/* ===== Bot Drawer (positioned within chat-interface) ===== */
.bot-drawer-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: var(--z-overlay);
  animation: overlay-fade-in 0.2s ease;
}

@keyframes overlay-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.bot-drawer {
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  max-width: 85%;
  height: 100%;
  background: var(--bg-elevated);
  backdrop-filter: blur(var(--blur-lg));
  -webkit-backdrop-filter: blur(var(--blur-lg));
  border-left: 1px solid var(--glass-border);
  z-index: var(--z-modal);
  display: flex;
  flex-direction: column;
  animation: drawer-slide-in 0.3s var(--ease-out-expo);
}

@keyframes drawer-slide-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.bot-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-lg);
  border-bottom: 1px solid var(--glass-border);
  flex-shrink: 0;
}

.bot-drawer-title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.bot-drawer-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: none;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-full);
  color: var(--text-tertiary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.bot-drawer-close:hover {
  color: var(--text-primary);
  border-color: var(--text-tertiary);
  background: var(--glass-bg);
}

.bot-drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: var(--spacing-md);
}

.bot-section {
  margin-bottom: var(--spacing-lg);
}

.bot-section-title {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wider);
  color: var(--text-tertiary);
  padding: var(--spacing-xs) var(--spacing-sm);
  margin-bottom: var(--spacing-xs);
}

.bot-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
}

.bot-item-clickable {
  cursor: pointer;
}

.bot-item-clickable:hover {
  background: var(--bg-hover);
}

.bot-item-disabled {
  opacity: 0.45;
  cursor: default;
}

.bot-avatar {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.bot-status-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: var(--radius-full);
  border: 2px solid var(--bg-elevated);
}

.bot-status-dot.online {
  background: var(--color-success);
  box-shadow: 0 0 6px var(--color-success-glow);
}

.bot-status-dot.offline {
  background: var(--text-tertiary);
}

.bot-info {
  flex: 1;
  min-width: 0;
}

.bot-name {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.bot-type {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-normal, 400);
  color: var(--text-tertiary);
}

.bot-description {
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bot-action {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.bot-action-remove {
  background: none;
  border: 1px solid var(--glass-border);
  color: var(--text-tertiary);
}

.bot-action-remove:hover {
  color: var(--color-error);
  border-color: var(--color-error);
}

.bot-action-config {
  background: none;
  border: 1px solid var(--glass-border);
  color: var(--text-tertiary);
  font-size: var(--font-size-base);
  line-height: 1;
}

.bot-action-config:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.bot-badge-host {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-md);
  color: var(--color-primary);
  border: 1px solid var(--color-primary);
  opacity: 0.7;
  white-space: nowrap;
}

.bot-action-add {
  color: var(--color-primary);
}

.bot-item-clickable:hover .bot-action-add {
  color: var(--color-primary-hover);
}

.bot-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2xl) var(--spacing-lg);
  text-align: center;
}

.bot-empty-text {
  margin: var(--spacing-md) 0 var(--spacing-xs) 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.bot-empty-hint {
  margin: 0;
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .chat-header {
    padding: var(--spacing-sm) var(--spacing-md);
  }

  .chat-back-button {
    display: flex;
  }

  .chat-title {
    font-size: var(--font-size-lg);
  }

  .bots-button {
    padding: var(--spacing-xs) var(--spacing-sm);
    font-size: var(--font-size-xs);
  }

  .bot-drawer {
    width: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../../../packages/apps/myagent/myagent_ui/src/components/ChatInterface.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAIF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mFAAmF;EACnF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,2CAA2C;EAC3C,qFAAqF;EACrF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,6CAA6C;EAC7C,4BAA4B;EAC5B,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,wCAAwC;EACxC,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,6CAA6C;EAC7C,0CAA0C;EAC1C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4CAA4C;EAC5C,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4CAA4C;IAC5C,8BAA8B;EAChC;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/**\n * ChatInterface - Ethereal Tech Design\n *\n * Pure chat view: header, messages, input, bot drawer.\n * Positioned within the main panel of AppLayout.\n */\n\n@import \"../styles/variables.css\";\n\n.chat-interface {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: transparent;\n  color: var(--text-primary);\n  z-index: 1;\n}\n\n/* ===== Header ===== */\n.chat-header {\n  position: relative;\n  flex-shrink: 0;\n  padding: var(--spacing-md) var(--spacing-lg);\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-md));\n  -webkit-backdrop-filter: blur(var(--blur-md));\n  border-bottom: 1px solid var(--glass-border);\n  z-index: var(--z-header);\n}\n\n.chat-header::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, transparent 100%);\n  pointer-events: none;\n}\n\n.chat-header-content {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.chat-header-left {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.chat-back-button {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: none;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  color: var(--text-tertiary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.chat-back-button:hover {\n  color: var(--text-primary);\n  border-color: var(--color-primary);\n  background: var(--glass-bg);\n}\n\n.chat-title {\n  margin: 0;\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--letter-spacing-tight);\n  background: linear-gradient(135deg, var(--text-primary) 0%, var(--color-accent) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  cursor: default;\n}\n\n.chat-title-input {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  padding: 2px 6px;\n  font-family: inherit;\n  -webkit-text-fill-color: var(--text-primary);\n  background: var(--glass-bg);\n  outline: none;\n  width: 200px;\n}\n\n.chat-header-right {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n}\n\n/* ===== Bots Button ===== */\n.bots-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--glass-bg);\n  backdrop-filter: blur(var(--blur-sm));\n  -webkit-backdrop-filter: blur(var(--blur-sm));\n  color: var(--text-secondary);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  white-space: nowrap;\n}\n\n.bots-button:hover {\n  color: var(--text-primary);\n  border-color: var(--color-primary);\n  box-shadow: 0 0 20px var(--color-primary-glow);\n}\n\n.bots-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  background: var(--color-primary);\n  color: white;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: var(--font-weight-semibold);\n  line-height: 1;\n}\n\n/* ===== Bot Drawer (positioned within chat-interface) ===== */\n.bot-drawer-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  z-index: var(--z-overlay);\n  animation: overlay-fade-in 0.2s ease;\n}\n\n@keyframes overlay-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.bot-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 320px;\n  max-width: 85%;\n  height: 100%;\n  background: var(--bg-elevated);\n  backdrop-filter: blur(var(--blur-lg));\n  -webkit-backdrop-filter: blur(var(--blur-lg));\n  border-left: 1px solid var(--glass-border);\n  z-index: var(--z-modal);\n  display: flex;\n  flex-direction: column;\n  animation: drawer-slide-in 0.3s var(--ease-out-expo);\n}\n\n@keyframes drawer-slide-in {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.bot-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-lg);\n  border-bottom: 1px solid var(--glass-border);\n  flex-shrink: 0;\n}\n\n.bot-drawer-title {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.bot-drawer-close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: none;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-full);\n  color: var(--text-tertiary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.bot-drawer-close:hover {\n  color: var(--text-primary);\n  border-color: var(--text-tertiary);\n  background: var(--glass-bg);\n}\n\n.bot-drawer-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--spacing-md);\n}\n\n.bot-section {\n  margin-bottom: var(--spacing-lg);\n}\n\n.bot-section-title {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wider);\n  color: var(--text-tertiary);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  margin-bottom: var(--spacing-xs);\n}\n\n.bot-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-md);\n  padding: var(--spacing-sm);\n  border-radius: var(--radius-md);\n  transition: background var(--transition-fast);\n}\n\n.bot-item-clickable {\n  cursor: pointer;\n}\n\n.bot-item-clickable:hover {\n  background: var(--bg-hover);\n}\n\n.bot-item-disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.bot-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.bot-status-dot {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--bg-elevated);\n}\n\n.bot-status-dot.online {\n  background: var(--color-success);\n  box-shadow: 0 0 6px var(--color-success-glow);\n}\n\n.bot-status-dot.offline {\n  background: var(--text-tertiary);\n}\n\n.bot-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.bot-name {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n.bot-type {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-normal, 400);\n  color: var(--text-tertiary);\n}\n\n.bot-description {\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bot-action {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.bot-action-remove {\n  background: none;\n  border: 1px solid var(--glass-border);\n  color: var(--text-tertiary);\n}\n\n.bot-action-remove:hover {\n  color: var(--color-error);\n  border-color: var(--color-error);\n}\n\n.bot-action-config {\n  background: none;\n  border: 1px solid var(--glass-border);\n  color: var(--text-tertiary);\n  font-size: var(--font-size-base);\n  line-height: 1;\n}\n\n.bot-action-config:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.bot-badge-host {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-md);\n  color: var(--color-primary);\n  border: 1px solid var(--color-primary);\n  opacity: 0.7;\n  white-space: nowrap;\n}\n\n.bot-action-add {\n  color: var(--color-primary);\n}\n\n.bot-item-clickable:hover .bot-action-add {\n  color: var(--color-primary-hover);\n}\n\n.bot-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2xl) var(--spacing-lg);\n  text-align: center;\n}\n\n.bot-empty-text {\n  margin: var(--spacing-md) 0 var(--spacing-xs) 0;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n.bot-empty-hint {\n  margin: 0;\n  font-size: var(--font-size-xs);\n  color: var(--text-tertiary);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .chat-header {\n    padding: var(--spacing-sm) var(--spacing-md);\n  }\n\n  .chat-back-button {\n    display: flex;\n  }\n\n  .chat-title {\n    font-size: var(--font-size-lg);\n  }\n\n  .bots-button {\n    padding: var(--spacing-xs) var(--spacing-sm);\n    font-size: var(--font-size-xs);\n  }\n\n  .bot-drawer {\n    width: 280px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
